import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { signInWithCustomToken } from 'firebase/auth';
import { useMutation, useQuery } from 'react-query';
import { getTemporaryImageUrlFromPublicUrl } from './services/DefaultService';

const firebaseConfig = {
  apiKey: 'AIzaSyBTXk9vRSBLCFC3cgeFoZvC9PMekp6B84I',
  authDomain: 'securyia.firebaseapp.com',
  projectId: 'securyia',
  storageBucket: 'securyia.firebasestorage.app',
  messagingSenderId: '549551006971',
  appId: '1:549551006971:web:8ef940910370415a1d3c5e',
  measurementId: 'G-JT7E10KRWT',
};

export const useFirebaseImageFromUrl = (publicUrl?: string) =>
  useQuery(
    ['firebase-image-url', publicUrl],
    async () => {
      if (!publicUrl) return null;

      await ensureFirebaseAuth(); // 🔐 garante login
      return await getTemporaryImageUrlFromPublicUrl(publicUrl);
    },
    {
      enabled: !!publicUrl,
      staleTime: 1000 * 60 * 5,
    },
  );
export const useFirebaseImageMutateFromUrl = () => {
  return useMutation(async (publicUrl: string) => {
    if (!publicUrl) throw new Error('URL vazia');

    await ensureFirebaseAuth(); // 🔐 garante login
    return await getTemporaryImageUrlFromPublicUrl(publicUrl);
  });
};
export async function ensureFirebaseAuth() {
  if (auth.currentUser) return;

  const encodedToken = sessionStorage.getItem('firebaseToken');
  if (!encodedToken) return;

  const firebaseToken = window.atob(encodedToken);

  await signInWithCustomToken(auth, firebaseToken);
}

export function extractFirebasePath(url: string): string {
  const decoded = decodeURIComponent(url);
  const match = decoded.match(/\/o\/(.+?)\?/);

  if (!match || !match[1]) {
    throw new Error('URL do Firebase inválida');
  }

  return match[1];
}

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
